import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Alert
} from '@mui/material';
import moment from 'moment';

const documentTypeLabels = {
  passport: 'Passport',
  drivers_license: 'Driver\'s License',
  national_id: 'National ID',
  utility_bill: 'Utility Bill',
  bank_statement: 'Bank Statement'
};

const KycDocumentsList = ({ documents = [] }) => {
  if (documents.length === 0) {
    return (
      <Alert severity="info" sx={{ mt: 2 }}>
        You haven't uploaded any KYC documents yet.
      </Alert>
    );
  }

  return (
    <Paper elevation={2} sx={{ mt: 3 }}>
      <Box p={2}>
        <Typography variant="h6" gutterBottom>
          Your KYC Documents
        </Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Document Type</TableCell>
                <TableCell>Document Number</TableCell>
                <TableCell>Expiry Date</TableCell>
                <TableCell>Submitted</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documents.map((doc) => (
                <TableRow key={doc.id}>
                  <TableCell>
                    {documentTypeLabels[doc.document_type] || doc.document_type}
                  </TableCell>
                  <TableCell>{doc.document_number || 'N/A'}</TableCell>
                  <TableCell>
                    {doc.expiry_date 
                      ? moment(doc.expiry_date).format('MMM DD, YYYY')
                      : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {moment(doc.created_at).format('MMM DD, YYYY')}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={doc.status.charAt(0).toUpperCase() + doc.status.slice(1)}
                      color={
                        doc.status === 'approved'
                          ? 'success'
                          : doc.status === 'rejected'
                          ? 'error'
                          : 'warning'
                      }
                      size="small"
                      variant="outlined"
                    />
                    {doc.status === 'rejected' && doc.rejection_reason && (
                      <Typography variant="caption" color="error" display="block">
                        Reason: {doc.rejection_reason}
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  );
};

export default KycDocumentsList;
